module.exports = __webpack_public_path__ + "8bbe15e41ca1564f25e629014128be81.fbx";